export default {

    Items: 'الصنف|الأصناف',
};
